import ActionType from 'store/actionTypes';
import {IState} from '../types';

export default function status(status?: IState) {
  return {type: ActionType.UPDATE_STATUS, data: status};
}
